import { getIngresarProductoById, useFetchGetIngresarProducto } from "@/shared/actions/erp"
import { CustomAutocompleteNoForm, GeneralTable, SearchComponente } from "@/shared/components/ui";
import useTableIngresoInventarioOrdenFinalizado from "../../shared/useTableIngresoInventarioOrdenFinalizado";
import { gridSize, gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg6, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared";
import {  Grid, IconButton, Tooltip,} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState } from "react";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import useTableFilterMulti from "@/shared/hooks/useTableFilterMulti";
import CustomRangeDate from "@/shared/components/ui/CustomRangeCalendar";
import { EnumChoiceOptions } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import ActionsBar from "@/shared/components/ui/ActionBar";
import { toast } from "react-toastify";
import { useFileDowloadDoc } from "@/shared/hooks/useDownloadFileDoc";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import LoaderLinearProgress from "@/shared/components/ui/LoaderLinear/LoaderLinearProgress";


export default function IngresoInventarioOrdenFinalizado() {
  useCheckPermissions(PermissionsEnum.api_view_ingresoinventario)
  ///store
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationTable = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)
  ///state
  const [searchTermOption, setSeacrchOptions] = useState('')
  const [urlPdf, setUrlPdf] = useState('')
  //********hook
  const { pagination, setPagination, onChangeFilter1, globalFilters1, searchTerms1, } = useTableFilterMulti()
  const {
    onChangeFilter,
    globalFilter,
    onChangeRangeDate,
    dateAfter,
    dateBefore,
    cleanFilter,
    /*     searchTerm,
        setSearchTerm, */

  } = useTableFilter()

  const { pageIndex, pageSize } = pagination
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()
  const { infoIngresoInventario, infoProducto, /* columnsIngresoInventario */ } = useTableIngresoInventarioOrdenFinalizado()
  const { downloadFile } = useFileDowloadDoc()

  ///FETCH
  const { data: dataIngrseoInventario, isLoading

  } = useFetchGetIngresarProducto(
    {
      enabled: true,
      params: {
        page: pageIndex + 1,
        page_size: pageSize,
        ...searchTerms1,

        orden_compra_isnull: false,
        fecha_creacion_range_before: dateBefore,
        fecha_creacion_range_after: dateAfter,
        //productos: searchTerm,
        //numero_guia_remision: searchTerm,
        //numero_factura: searchTerm,
        //productos:searchTerms, 
        ...filterObject,
        filterByState: false
      }
    })


  //*********************state
  const [isOpenModal, setIsOpenModal] = useState(false)
  ////***********************function
  const onDetails = (data: any) => {
    setUrlPdf(data.url_pdf)
    handleCopiarLista(data.productos)
    setIsOpenModal(true)
  }

  //
  const options = Object.entries(EnumChoiceOptions).map(([value, label]) => ({
    value, label
  }))

  //**download */
  const handleDowload = async () => {
    if (!urlPdf) return toast.error('No dispone ningun ingreso')
    downloadFile({
      url: urlPdf,
      nameFile: 'Ingreso Mercaderia',
      extensionFile: 'pdf'
    })
  }
  //
  const onDownload = (e: string) => {
    downloadFile({
      url: e,
      nameFile: 'Ingreso Mercaderia'
    })
  }
  ///if (isLoading) return <LoaderComponent />
  //useLoaders(isLoading)
  return (
    <>

      <Grid container spacing={2} alignItems={"center"}>

        <Grid item {...gridSizeMdLg6}>
          <SearchComponente
            value={globalFilters1[searchTermOption] || ""}
            text="por factura/producto/Remisión"
            onChange={(value) => onChangeFilter1(searchTermOption, value)}
          />
        </Grid>
        <CustomAutocompleteNoForm
          label="Tipo de búsqueda *"
          //name="label"
          options={options}
          valueKey={'label'}
          actualValueKey={'value'}
          defaultValue={''}
          isLoadingData={false}
          onChangeValue={(value) => {
            if (value !== searchTermOption) {
              // Limpio el filtro anterior
              onChangeFilter1(searchTermOption, '');
              // Seteo el nuevo tipo de búsqueda
              setSeacrchOptions(value);
            } else {
              // Si es el mismo valor, solo lo seteo (o nada)
              setSeacrchOptions(value);
            }

          }}
          size={gridSizeMdLg3}
        />


        <Grid item {...gridSizeMdLg3}>
          <CustomRangeDate
            onChange={onChangeFilter}
            value={globalFilter}
            text="Rango"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          />
        </Grid>

        <Grid item {...gridSizeMdLg12}>
          {isLoading && (
            <LoaderLinearProgress></LoaderLinearProgress>
          )}
        </Grid>

        <Grid item {...gridSizeMdLg12}>
          <GeneralTable
            columns={infoIngresoInventario}
            data={dataIngrseoInventario?.data.data || []}
            isLoading={isLoading}
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataIngrseoInventario?.data.count}
            canEdit={false}
            enableColumnActions={true}
            //
            enableGlobalFilter={false}
            //filter side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            //acciones
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              return (
                <>
                  <Grid container >
                    <Grid item>
                      <Tooltip title="Ver Detalles" placement={'top'}>
                        <IconButton
                          onClick={() => { onDetails(value) }}
                        >
                          <VisibilityIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      <Tooltip title="Descargar" placement="top">
                        <IconButton
                          onClick={async () => {
                            let url = value?.url_pdf
                            if (!url) {

                              try {
                                const response: any = await getIngresarProductoById(value?.id_ingreso_inventario!)
                                url = response?.data?.url_pdf ?? null
                              } catch (error) {
                                return toast.error("Error al generar el documento.")
                              }
                            }
                            if (!url) {
                              return toast.info('No existe documento. [404]')
                            }
                            onDownload(url!)
                          }}
                        >
                          <CloudDownloadIcon color="success" />
                        </IconButton>
                      </Tooltip>

                    </Grid>

                  </Grid>
                </>
              )
            }}
          />
        </Grid>
      </Grid>
      <ScrollableDialogProps
        open={isOpenModal}
        title="Detalle Producto"
        onCloseIcon={() => setIsOpenModal(false)}
        minWidth="65%"
        contentNode={
          <>
            <Grid container justifyContent={'flex-end'} justifyItems={'flex-end'}>
              <Grid item {...gridSize} spacing={2} container justifyContent={'flex-end'}>
                <Grid item>
                  <ActionsBar
                    downLoadLabel={'Descargar Ingreso'}
                    showPrint={false}
                    onDownload={handleDowload}
                  >
                  </ActionsBar>
                </Grid>

              </Grid>

              <Grid item {...gridSizeMdLg12} my={2}>
                <SampleTablePagination
                  columns={infoProducto}
                  data={paginatedData}
                  rowCount={productos.length}
                  pagination={paginationTable}
                  setPagination={setPaginationTable}
                />
              </Grid>
            </Grid>

          </>
        }
      />

    </>
  )
}